import Vue from 'vue'
import App from './App.vue'
// import router from "./router";
import i18n from '@/i18n'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import * as Sentry from '@sentry/vue'

Vue.config.productionTip = false

Sentry.init({
  Vue: Vue,
  dsn: 'https://e1b20aaf7a0742d08ec5afd5ec884fff@o459666.ingest.sentry.io/5757186',
  ignoreErrors: [
    'Cannot read property "url" of undefined'
  ],
  beforeSend (event, hint) {
    // @ts-ignore
    if (hint.originalException.config.url === 'api/v1/user/analyticsId') {
      // @ts-ignore
      event = null
    }
    return event
  }
})

new Vue({
  router,
  i18n,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
